import React, { useEffect, useState } from "react";
import baseUrl from "../../../../api/baseUrl";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";

function NavTime({ setformData, onClose }: any) {
  const [timeData, settimeData] = useState({
    from: "09:00",
    to: "17:00",
    timeDuration: "30",
  });

  useEffect(() => {
    baseUrl
      .get("/clinic/getTimeData")
      .then((response) => {
        if (response.data.data.startTime) {
          setformData((prevData: any) => ({
            ...prevData,
            from: response.data.data.startTime,
            to: response.data.data.endTime,
          }));
          settimeData((prevData: any) => ({
            ...prevData,
            from: response.data.data.startTime,
            to: response.data.data.endTime,
          }));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setformData]);

  const handleChange = (e: any) => {
    settimeData({ ...timeData, [e.target.name]: e.target.value });
  };

  const handleTimeSave = () => {
    baseUrl
      .post("/clinic/addTimeData", {
        startTime: timeData.from,
        endTime: timeData.to,
      })
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white text-slate-800 shadow-lg shadow-black/10 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 dark:border-slate-700">
        <div className="flex items-center gap-2">
          <AccessTimeIcon
            className="text-slate-600 dark:text-slate-300"
            sx={{ fontSize: 18 }}
          />
          <h3 className="text-sm font-semibold">Clinic Hours</h3>
        </div>

        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-8 w-8 items-center justify-center rounded-md text-slate-600 hover:bg-slate-100 hover:text-slate-900 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-primary/60 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100 dark:focus-visible:ring-offset-slate-900"
            aria-label="Close"
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </button>
        )}
      </div>

      <div className="p-4">
        <div className="flex flex-col gap-3">
          <div>
            <label className="block text-xs font-medium text-slate-600 dark:text-slate-300">
              From
            </label>
            <input
              type="time"
              onChange={handleChange}
              value={timeData.from}
              name="from"
              className="mt-1 w-full rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-sm outline-none transition-colors focus:border-primary dark:border-slate-700 dark:bg-slate-950"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-600 dark:text-slate-300">
              To
            </label>
            <input
              type="time"
              onChange={handleChange}
              value={timeData.to}
              name="to"
              className="mt-1 w-full rounded-md border border-slate-200 bg-white px-2.5 py-1.5 text-sm outline-none transition-colors focus:border-primary dark:border-slate-700 dark:bg-slate-950"
            />
          </div>

          <div className="flex flex-col gap-2 sm:flex-row">
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="inline-flex h-9 w-full items-center justify-center rounded-md border border-slate-200 bg-white px-3 text-xs font-semibold text-slate-700 transition-colors hover:bg-slate-50 active:bg-slate-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
              >
                Cancel
              </button>
            )}
            <button
              onClick={() => handleTimeSave()}
              className="inline-flex h-9 w-full items-center justify-center gap-1.5 rounded-md bg-primary px-3 text-xs font-semibold text-white transition-colors hover:bg-primary/90 active:bg-primary/80"
            >
              <SaveIcon sx={{ fontSize: 16 }} />
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NavTime;
